import {
  ImageScaleView,
  ImageScaleViewOpts,
  ImageView,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import Match2PinchMovesIcon from './Match2PinchMovesIcon';
import { getAdContinueMoves } from 'src/game/ads/ads.util';

export default class Match2AdContinuePanel extends ImageScaleView {
  constructor(
    opts: Omit<
      ImageScaleViewOpts,
      'image' | 'width' | 'height' | 'centerOnOrigin' | 'centerAnchor'
    > & { amount: number },
  ) {
    super({
      ...opts,
      width: 253,
      height: 213,
      centerOnOrigin: true,
      centerAnchor: true,
      image: 'assets/ui/match2/common/panel_pinch.png',
    });

    // FlexBox doesn't play well with scale, so align manually
    new Match2PinchMovesIcon({
      superview: this,
      amount: getAdContinueMoves(0),
      scale: 0.5,
      x: 50,
      y: 80,
    });

    new ImageView({
      superview: this,
      image: 'assets/ui/shared/icons/arrow_right.png',
      x: 83,
      y: 70,
      width: 21,
      height: 40,
      scale: 0.6,
    });

    new Match2PinchMovesIcon({
      superview: this,
      amount: getAdContinueMoves(1),
      scale: 0.5,
      x: 126,
      y: 80,
    });

    new ImageView({
      superview: this,
      image: 'assets/ui/shared/icons/arrow_right.png',
      x: 159,
      y: 70,
      width: 21,
      height: 40,
      scale: 0.6,
    });

    new Match2PinchMovesIcon({
      superview: this,
      amount: getAdContinueMoves(2),
      scale: 0.5,
      x: 202,
      y: 80,
    });

    new LangBitmapFontTextView({
      superview: this,
      font: 'Body',
      color: '#BF8147',
      size: 20,
      width: this.style.width - 50,
      x: this.style.width * 0.5,
      y: 165,
      centerOnOrigin: true,
      centerAnchor: true,
      localeText: () =>
        i18n('match2.adContinue.buyMessage', { amount: opts.amount }),
      verticalAlign: 'center',
      align: 'center',
    });
  }
}
